import { Component, OnInit, ViewChild } from '@angular/core';
import { CaseComponent } from '../../components/case-base/case.component';
import { ComponentServiceBundle } from '@app/core/services/base/component-service-bundle.service';
import { CaseService } from '@app/core/services/case.service';
import {
  AddressParticipantComponent,
  AddressParticipantOptions
} from '@app/modules/case/components/address-participant/address-participant.component';
import { ParticipantTypes } from '@app/shared/models/participant-type';
import { CaseParticipantUriBuilderParams, ParticipantsService } from '@app/core/services/participants.service';
import * as _ from 'lodash-es';
import { Participant, PotentialParticipant, PotentialParticipantList } from '@app/shared/models/participant';
import { BaseList, BaseWithIdList } from '@app/shared/models/list';
import { TranslationEntry } from '@app/shared/models/translatable';
import { AmountPerRowScreenSizeConfig } from '@app/shared/components/dynamic-checkboxes/dynamic-checkboxes.component';
import { PotentialParticipantService } from '@app/core/services/potential-participant.service';
import { OP } from '@app/core/services/base/base-service-with-bundle.service';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { MatLegacySelect as MatSelect } from '@angular/material/legacy-select';
import { forkJoin } from 'rxjs';
import { OfficeService, OfficeUriBuilderParams } from '@app/core/services/office.service';
import { Office } from '@app/shared/models/office';
import { DateTimePickerOptions } from '@app/shared/components/date-time-picker/date-time-picker.component';
import {ClaimType} from "@app/shared/models/claim-type";
import {ClaimTypeService, ClaimTypeUriBuilderParams} from "@app/core/services/claim-type.service";


@Component({
  templateUrl: './case-quick.component.html',
  styleUrls: ['./case-quick.component.scss']
})
export class CaseQuickComponent extends CaseComponent
                                implements OnInit {

  @ViewChild('customerAddress')
  public customerAddressParticipantComponent: AddressParticipantComponent;

  @ViewChild('accidentOpponentAddress')
  public accidentOpponentAddressParticipantComponent: AddressParticipantComponent;

  @ViewChild('accidentOpponent2Address')
  public accidentOpponent2AddressParticipantComponent: AddressParticipantComponent;

  @ViewChild('serviceConsultantSelect')
  public serviceConsultantSelect: MatSelect;

  @ViewChild('salesManagerSelect')
  public salesManagerSelect: MatSelect;

  @ViewChild('assessorSelect')
  public assessorSelect: MatSelect;

  @ViewChild('lawyerSelect')
  public lawyerSelect: MatSelect;

  @ViewChild('clerkSelect')
  public clerkSelect: MatSelect;

  public claimDateTimePickerOptions: DateTimePickerOptions;
  public customerType = ParticipantTypes.CUSTOMER.key;
  public accidentOpponentType = ParticipantTypes.ACCIDENT_OPPONENT_VEHICLE_OWNER.key;
  public accidentOpponent2Type = ParticipantTypes.ACCIDENT_OPPONENT_INSURANCE.key;
  public customerOptions: AddressParticipantOptions[];
  public accidentOpponentOptions: AddressParticipantOptions[];
  public accidentOpponent2Options: AddressParticipantOptions[];
  public claimTypesList: BaseWithIdList<ClaimType>;
  public damageTypes: string[];

  public readonly customerExtraTypes = [
    ParticipantTypes.VEHICLE_OWNER,
    ParticipantTypes.VEHICLE_HOLDER
  ];

  public customerDisabledTypes: string[];

  public checkboxAmountPerRowForScreenSize: AmountPerRowScreenSizeConfig = {
    xs: { amount: 1, col: 'col-12' },
    sm: { amount: 1, col: 'col-12' },
    md: { amount: 2, col: 'col-6' },
    lg: { amount: 2, col: 'col-6' },
    xl: { amount: 2, col: 'col-6' }
  };

  public officeList: BaseWithIdList<Office>;

  protected _selectedOffice: Office;

  get selectedOffice(): Office {
    return this._selectedOffice;
  }

  set selectedOffice(value: Office) {
    if (value !== this._selectedOffice) {
      this._selectedOffice = value;
      this.patchOffice(this._selectedOffice);
    }
  }

  get selectedClaimType(): ClaimType {
    return this.case && this.claimTypesList && this.claimTypesList.getItem(this.case.claim_type_id);
  }
  set selectedClaimType(type: ClaimType) {
    const patchData = [{
      op: type ? OP.replace : OP.remove,
      path: 'claim_type_id',
      value: type ? type.id : null
    }, {
      op: type ? OP.replace : OP.remove,
      path: 'claim_type',
      value: type ? type.name : null
    }];

    this.patchOpDataArray(patchData);
  }

  private potentialParticipantsList: PotentialParticipantList[];
  public participantsList: BaseWithIdList<Participant>;

  private _serviceConsultant: PotentialParticipant;
  private _salesManager: PotentialParticipant;
  private _assessor: PotentialParticipant;
  private _clerk: PotentialParticipant;
  private _lawyer: PotentialParticipant;

  get serviceConsultant() {
    return this._serviceConsultant;
  }

  set serviceConsultant(value: PotentialParticipant) {
    if (value !== this._serviceConsultant) {
      this.patchPotentialParticipantOfType(ParticipantTypes.SERVICE_CONSULTANT.key, value);
    }
  }

  get salesManager() {
    return this._salesManager;
  }

  set salesManager(value: PotentialParticipant) {
    if (value !== this._salesManager) {
      this.patchPotentialParticipantOfType(ParticipantTypes.SALES_MANAGER.key, value);
    }
  }

  get assessor() {
    return this._assessor;
  }

  set assessor(value: PotentialParticipant) {
    if (value !== this._assessor) {
      this.patchPotentialParticipantOfType(ParticipantTypes.ASSESSOR.key, value);
    }
  }

  get clerk() {
    return this._clerk;
  }

  set clerk(value: PotentialParticipant) {
    if (value !== this._clerk) {
      this.patchPotentialParticipantOfType(ParticipantTypes.CLERK.key, value);
    }
  }

  get lawyer() {
    return this._lawyer;
  }

  set lawyer(value: PotentialParticipant) {
    if (value !== this._lawyer) {
      this.patchPotentialParticipantOfType(ParticipantTypes.LAWYER.key, value);
    }
  }

  get ParticipantTypes() {
    return ParticipantTypes;
  }

  get offices(): Office[] {
    return (this.officeList && this.officeList.items) || [];
  }

  get serviceConsultantList(): PotentialParticipant[] {
    return this.getPotentialParticipantsOfType(ParticipantTypes.SERVICE_CONSULTANT.key);
  }

  get salesManagerList(): PotentialParticipant[] {
    return this.getPotentialParticipantsOfType(ParticipantTypes.SALES_MANAGER.key);
  }

  get assessorList(): PotentialParticipant[] {
    return this.getPotentialParticipantsOfType(ParticipantTypes.ASSESSOR.key);
  }

  get clerkList(): PotentialParticipant[] {
    return this.getPotentialParticipantsOfType(ParticipantTypes.CLERK.key);
  }

  get lawyerList(): PotentialParticipant[] {
    return this.getPotentialParticipantsOfType(ParticipantTypes.LAWYER.key);
  }

  constructor(protected componentServiceBundle: ComponentServiceBundle,
              protected caseService: CaseService,
              protected potentialParticipantService: PotentialParticipantService,
              protected participantsService: ParticipantsService,
              protected officeService: OfficeService,
              protected claimTypeService: ClaimTypeService,
              ) {
    super(componentServiceBundle, caseService);
    this._idPrefix = 'case_quick.';
  }

  public ngOnInit() {
    super.ngOnInit();

    this.accidentOpponentOptions = [
      AddressParticipantOptions.TITLE,
      AddressParticipantOptions.NAME,
      AddressParticipantOptions.MULTI_NAMES,
      AddressParticipantOptions.PHONE
    ];
    this.accidentOpponent2Options = [
      AddressParticipantOptions.NAME
    ];

    this.customerOptions = [
      AddressParticipantOptions.TITLE,
      AddressParticipantOptions.NAME,
      AddressParticipantOptions.MULTI_NAMES,
      AddressParticipantOptions.ADDRESS,
      AddressParticipantOptions.COUNTRY,
      AddressParticipantOptions.EMAIL,
      AddressParticipantOptions.PHONE
    ];

    this.damageTypes = [
      'collision',
      'parking',
      'driveways',
      'animal',
      'total_theft',
      'storm_hail_damage',
      'right_before_left',
      'vehicle_breakdown',
      'theft',
      'fire_damage',
      'glass_damage',
      'lane_change',
      'miscellaneous'
    ];

    this.claimTypeService.query(new ClaimTypeUriBuilderParams())
        .subscribe((result) => {
          this.claimTypesList = result;
        });
  }

  protected whenOriginalFetched(): void {
    super.whenOriginalFetched();

    this.claimDateTimePickerOptions = {
      datePatchPath: 'claim_date',
      timePatchPath: 'claim_date_usertime',
      dateLabel: this.case.trans.claim_date,
      timeLabel: this.case.trans.claim_date_usertime
    };

    const observables = [
      this.participantsService.query(new CaseParticipantUriBuilderParams(this.case)),
      this.potentialParticipantService.query(),
      this.officeService.query(new OfficeUriBuilderParams(), null, 'offices')
    ];

    forkJoin(observables).subscribe((results: any) => {
      this.participantsList = results[0];
      this.potentialParticipantsList = results[1];
      this.officeList = results[2];

      if (this.case.office_id) {
        this._selectedOffice = this.officeList.getItem(this.case.office_id);
      }

      this.customerDisabledTypes = this.fillDisabledTypes(ParticipantTypes.CUSTOMER, this.participantsList);
      this.initPotentials();
    }, err => {
      this.handleError(err);
    });
  }

  public finishCaseEditing(): void {
  }

  private getPotentialParticipantsOfType(participantTypeKey: string): PotentialParticipant[] {
    if (this.potentialParticipantsList) {
      const found = this.potentialParticipantsList.find(entry => entry.participant_type === participantTypeKey);
      return found.items;
    } else {
      return [];
    }
  }

  private initPotentials(): void {
    this._serviceConsultant = this.findPotentialByCaseParticipant(ParticipantTypes.SERVICE_CONSULTANT.key);
    this._salesManager = this.findPotentialByCaseParticipant(ParticipantTypes.SALES_MANAGER.key);
    this._assessor = this.findPotentialByCaseParticipant(ParticipantTypes.ASSESSOR.key);
    this._clerk = this.findPotentialByCaseParticipant(ParticipantTypes.CLERK.key);
    this._lawyer = this.findPotentialByCaseParticipant(ParticipantTypes.LAWYER.key);
  }

  private findPotentialByCaseParticipant(participantTypeKey: string): PotentialParticipant {
    const caseParticipant = this.getParticipantOfType(participantTypeKey);
    return caseParticipant ? this.getPotentialParticipantsOfType(participantTypeKey).find(potPart => potPart.id === caseParticipant.source_id) : null;
  }

  private fillDisabledTypes(excludedType: TranslationEntry, list: BaseList<Participant>): string[] {
    const disabled = [];
    _.each(list.items, (part) => {
      if (!part.isOfType(excludedType.key)) {
        _.forEach(part.type, (type) => {
          const isExtraType = this.customerExtraTypes.find(cType => cType.key === type);
          if (isExtraType) {
            disabled.push(type);
          }
        });
      }
    });

    return disabled;
  }

  private patchPotentialParticipantOfType(participantTypeKey: string, value: PotentialParticipant): void {
    this.setPublicPotParticipantValueByType(participantTypeKey, value);

    const participantOfType = this.getParticipantOfType(participantTypeKey);

    if (value && participantOfType && !participantOfType.source_id) {
     this.showSimpleConfirmDialog(marker('quick_processing.warning.existing_participant.title'),
                                  this.translateService.instant(marker('quick_processing.warning.existing_participant.text'),
                                                { participantType: this.translateService.instant(ParticipantTypes.getTypeByKey(participantTypeKey).trans),
                                                                  participantName: participantOfType.displayName
                                                                })
                                 )
         .subscribe(result => {
        if (result) {
          this.deleteAndReplaceParticipant(participantTypeKey, participantOfType, value);
        } else {
          this.setPublicPotParticipantValueByType(participantTypeKey, null);
        }
     });
    } else {
      if (participantOfType) {
        this.deleteAndReplaceParticipant(participantTypeKey, participantOfType, value);
      } else if (value) {
        this.patchPotentialParticipant(participantTypeKey, value);
      }
    }
  }

  private deleteAndReplaceParticipant(participantTypeKey: string, participantOfType: Participant, value: PotentialParticipant): void {
    this.participantsService.delete(new CaseParticipantUriBuilderParams(this.case, participantOfType))
        .subscribe(deleteResult => {
          this.participantsList.removeItem(participantOfType);
          this.patchPotentialParticipant(participantTypeKey, value);
        });
  }

  private setPublicPotParticipantValueByType(participantTypeKey: string, value: PotentialParticipant) {
    switch (participantTypeKey) {
      case ParticipantTypes.SERVICE_CONSULTANT.key: {
        this._serviceConsultant = value;
        this.serviceConsultantSelect.value = value;
        break;
      }
      case ParticipantTypes.SALES_MANAGER.key: {
        this._salesManager = value;
        this.salesManagerSelect.value = value;
        break;
      }
      case ParticipantTypes.ASSESSOR.key: {
        this._assessor = value;
        this.assessorSelect.value = value;
        break;
      }
      case ParticipantTypes.CLERK.key: {
        this._clerk = value;
        this.clerkSelect.value = value;
        break;
      }
      case ParticipantTypes.LAWYER.key: {
        this._lawyer = value;
        this.lawyerSelect.value = value;
        break;
      }
      default: {
        break;
      }
    }
  }

  private patchPotentialParticipant(participantTypeKey: string, potParticipant: PotentialParticipant): void {
    if (potParticipant) {
      const data = [{
        op: OP.replace,
        path: 'source_id',
        value: potParticipant.id
      }, {
        op: OP.replace,
        path: 'source',
        value: potParticipant.source
      }];

      this.participantsService.patch(new CaseParticipantUriBuilderParams(this.case), data, { urlSuffix: participantTypeKey })
                              .subscribe(result => {
             if (result.type.indexOf(participantTypeKey) === -1) {
               result.type.push(participantTypeKey);
             }

             this.participantsList.addItem(result);
          }, err => this.handleError(err));
    }
  }

  private getParticipantOfType(participantTypeKey: string): Participant {
    return this.participantsList.items.find(part => part.isOfType(participantTypeKey));
  }

  protected  patchOffice(office: Office, callbackFn?: Function): void {
    super.patchOffice(office, (result) => {
      if (this.case.office_id) {
        this._selectedOffice = this.officeList.getItem(this.case.office_id);
      }

      if (callbackFn) {
        callbackFn(result);
      }
    });
  }
}
